// extracted by mini-css-extract-plugin
module.exports = {"canvas":"main_canvas__1V2Y3","container":"main_container__3tW0A"};